import classnames from 'classnames'
import { Icon } from '../Icon/Icon'

type ToggleProps = {
    checked: boolean
    disabled?: boolean
    onChange?: (checked: boolean) => void
}

export const Toggle: React.FC<ToggleProps> = ({
    checked,
    disabled,
    onChange,
}) => {
    const wrapperClassname = classnames(
        'relative flex h-[24px] w-[42px] items-center rounded-xl transition-colors duration-200 focus:outline-none',
        {
            'bg-neutral-300': !disabled && !checked,
            'bg-azure': !disabled && checked,
            'bg-neutral-200': disabled && !checked,
            'bg-blue-200': disabled && checked,
        }
    )
    const toggleClassname = classnames(
        'absolute left-0.5 top-0.5 flex h-[20px] w-[20px] transform items-center justify-center rounded-full shadow-md transition-transform duration-200',
        {
            'translate-x-0': !checked,
            'translate-x-[18px]': checked,
            'bg-white': !disabled,
            'bg-neutral-100': disabled,
        }
    )

    return (
        <button
            type="button"
            disabled={disabled}
            onClick={() => {
                onChange?.(!checked)
            }}
            className={wrapperClassname}
            data-testid={'toggle-container'}
        >
            <span className={toggleClassname}>
                {checked && (
                    <Icon
                        name={'check'}
                        className={disabled ? 'text-blue-200' : 'text-azure'}
                        size="xxsmall"
                    />
                )}
            </span>
        </button>
    )
}
